import React from "react";

import { useTheme } from "../../../context/theme";
import {
  typographyBodyLineHeightMap,
  typographyBodySizeMap
} from "../../../styles/typography/typography";
import { Box } from "../../layout";

type Props = {
  children: React.ReactNode;
  dataTest?: string;
};

export default function FieldError(props: Props) {
  const { children, dataTest } = props;

  const theme = useTheme();

  return (
    <Box
      color={theme["contentOn-error-high-surface"]}
      backgroundColor={theme["error-high-surface"]}
      borderRadius="small"
      {...typographyBodySizeMap.small}
      {...typographyBodyLineHeightMap.small}
      fontWeight="bold"
      boxSizing="content-box"
      padding="large"
      dataTest={dataTest}
    >
      {children}
    </Box>
  );
}
